export enum Module {
    mech_plan = 'Monteursplanning',
    ser_contr = 'Servicecontracten',
    wvb = 'Werkvoorbereiding',
    mech_app = 'Monteurs App',
    non_conform = 'Non Conformiteiten',
    iss_track = 'Issue Tracker',
    templ_mngr = 'Template-Manager',
    ass_manage = 'Assets Beheer',
    settings = 'Instellingen',
    mat_req = 'Materiaal Issue-Tracker',
    mb_iss = 'Machine-Tracker',
    spa_parts = 'Spare-Parts',
    time_reg = 'Urenregistratie',
    prjct_mng = 'Projecten',
    tool_mange = 'Materieel & Gereedschap',
    clothes_equipment = 'Bedrijfskleding & PBM\'s',
    prjct_planning = 'Machinebouwplannning',
    dashboard = "Dashboard",
    tender_tracker = "Offerte-Funnel Tracker",
    calculations = "Calculaties",
    communication = "Communicatie",
    fin_admin = "Financiële Administratie",
    turnover_dashboard = "Omzetoverzicht",
    project_insights = "Projectoverzicht",
    mt_dashboard = "Management Dashboard",
    time_insights = "Urenoverzicht",
    tickets = "Tickets",
    rma_process = "RMA-Proces"
}

export enum ModuleIcon {
    mech_plan = 'bi-calendar-week',
    wvb = 'bi-list-check',
    mech_app = 'bi-person-lines-fill',
    non_conform = 'bi-exclamation-circle',
    iss_track = 'bi-bug-fill',
    templ_mngr = 'bi bi-files',
    settings = 'bi-gear',
    ass_manage = 'bi-boxes',
    ser_contr = 'bi-file-earmark-text',
    mat_req = 'bi-stack',
    mb_iss = 'bi bi-wrench-adjustable-circle',
    spa_parts = 'bi-nut',
    time_reg = 'bi-clock',
    prjct_mng = 'bi bi-kanban',
    tool_mange = 'bi bi-wrench',
    clothes_equipment = 'bi bi-universal-access-circle',
    prjct_planning = 'bi bi-bar-chart-steps',
    dashboard = "bi bi-speedometer",
    tender_tracker = "bi bi-file-earmark-ruled",
    calculations = "bi bi-calculator",
    communication = "bi bi-chat",
    fin_admin = "bi bi-receipt-cutoff",
    turnover_dashboard = "bi bi-cash-coin",
    project_insights = "bi bi-list",
    mt_dashboard = "bi bi-graph-up-arrow",
    time_insights = "bi bi-smartwatch",
    tickets = "bi bi-ticket-detailed",
    rma_process = "bi bi-x-octagon",
}

export enum ModuleLink {
    mech_plan = '/mechanic-planning-dashboard',
    service_req = '/service-requests-dashboard',
    mechanics = '/mechanic-dashboard',
    vehicles = '/vehicle-dashboard',

    rma_process = '/return-malfunctioning-articles',

    tickets = '/',

    wvb = '/work-preparation-dashboard',
    mech_app = '/',
    non_conform = '/non-conformities',
    iss_track = '/issue-tracker-dashboard',
    
    templ_mngr = '/template-manager',
    templ_mngr_proj = '/template-manager-projects',

    settings = '/settings-dashboard',
    ass_manage = '/asset-management',
    ser_contr = '/service-contracts',
    mat_req = '/material-issue-tracker',
    mb_iss = '/machine-issue-tracker',
    spa_parts = '/spare-parts',
    time_reg = '/time-registration',
    prjct_mng = '/project-management',
    tool_mange = '/tools-dashboard',
    clothes_equipment = '/clothes-equipment',
    prjct_planning = '/',
    dashboard = '/dashboard',
    tender_tracker = '/sales-funnel-tracker',
    communication = '/communication',

    calculations = '/calculations',
    calculation_information = '/calculations-information',
    standard_machines = '/standard-machines',
    
    fin_admin = '/fin-admin',
    hourly_rates = '/hourly-rates',
    department_budgets = '/department-budgets',

    turnover_dashboard = '/turnover-dashboard',
    turnover_insights = '/turnover-insights',
    turnover_standard_machines = '/standard-machines-vend',
    turnover_ohw = '/turnover-ohw',

    project_insights = '/project-insights',
    mt_dashboard = '/',
    time_insights = '/time-insights',

    portal = '/portal',
    signIn = '/sign-in'
}

export const getModuleIcon = (mod: string) => {
    return ModuleIcon[mod as keyof typeof ModuleIcon]
}

export const getModuleLink = (mod: string) => {
    return ModuleLink[mod as keyof typeof ModuleLink]
}

export const getModuleName = (mod: string) => {
    return Module[mod as keyof typeof Module]
}